import { useState, useEffect, useRef } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { ButtonWithSound } from '../Button/Button';
import { API } from 'aws-amplify';
import './ChatChallenge.scss';
import Cover from '../Conversation/cover.jpg'

const ChatChallenge = (props) => {
    const { login } = useSelector((state) => state.loginReducer, shallowEqual);
    
    const generateImageUrl = (baseUrl) => login.cloudFront + baseUrl + login.cookie;

    const [intro, setIntro] = useState(false);
    const [challenge, setChallenge] = useState(false);
    const [currentStepIndex, setCurrentStepIndex] = useState(0);
    const [showReminder, setShowReminder] = useState(false);
    const [reminderText, setReminderText] = useState('');
    const [revealedMessages, setRevealedMessages] = useState([]);
    const [score, setScore] = useState(0);
    const [scenario, setScenario] = useState();
    const [scenarioText, setScenarioText] = useState('');
    const [second, setSecond] = useState(false);
    const [scenarioAudio, setScenarioAudio] = useState('');
    const [scenarioExample, setScenarioExample] = useState('');
    const  [first, setFirst] = useState(false);
    const scrollRef = useRef();

    useEffect(() => {
        console.log(props.topicName);
        if(props.topicName === 'Favorite Things: Chat Challenge') {
            setScenario(generateImageUrl('images/newDesign/FreePlay/level4/Favorite_Challenge_Scenario.png'));
            setScenarioText('You will ask each other about your favorite animals.');
            setScenarioAudio(generateImageUrl('media/Freeplay/level4/chat/chat_favorite_things_prompt.mp3'));
            setScenarioExample(generateImageUrl('media/Freeplay/level4/chat/example_favorite_things.mp4'));
            setSecond(true);
        }
        else if(props.topicName === 'Talk about Feelings: Chat Challenge') {
            setScenario(generateImageUrl('images/newDesign/FreePlay/level4/Feelings_Challenge_Scenario.png'));
            setScenarioText(`You will talk about what makes you feel confident.`);
            setScenarioAudio(generateImageUrl('media/Freeplay/level4/chat/chat_talk_feelings_prompt.mp3'));
            setScenarioExample(generateImageUrl('media/Freeplay/level4/chat/example_talk_feelings.mp4'));
            setSecond(true);
        }
        else if(props.topicName === 'Active Listening: Chat Challenge') {
            setScenario(generateImageUrl('images/newDesign/FreePlay/level4/Listening_Challenge_Scenario.png'));
            setScenarioText(`You will talk about what makes you feel calm.`);
            setScenarioAudio(generateImageUrl('media/Freeplay/level4/chat/chat_active_listening_prompt.mp3'));
            setScenarioExample(generateImageUrl('media/Freeplay/level4/chat/example_active_listening.mp4'));
            setSecond(true);
        }
        else if(props.topicName === 'Making Friends: Chat Challenge') {
            setScenario(generateImageUrl('images/newDesign/FreePlay/level4/Friends_Challenge_Scenario.png'));
            setScenarioText('You will ask each other about your favorite things to do outside.');
            setScenarioAudio(generateImageUrl('media/Freeplay/level4/chat/chat_making_friends_prompt.mp3'));
            setScenarioExample(generateImageUrl('media/Freeplay/level4/chat/example_making_friends.mp4'));
            setSecond(true);
        }
        else if(props.topicName === 'Solutions: Chat Challenge') {
            setScenario(generateImageUrl('images/newDesign/FreePlay/level4/Solutions_Challenge_Scenario.png'));
            setScenarioText(`You will talk about what makes you feel nervous.`);
            setScenarioAudio(generateImageUrl('media/Freeplay/level4/chat/chat_solutions_prompt.mp3'));
            setScenarioExample(generateImageUrl('media/Freeplay/level4/chat/example_solutions.mp4'));
            setSecond(true);
        }
        else if(props.topicName === 'Resolve Conflict: Chat Challenge') {
            setScenario(generateImageUrl('images/newDesign/FreePlay/level4/Conflict_Challenge_Scenario.png'));
            setScenarioText('You’re sad because your friend is sitting where you wanted to sit on the bus.');
            setScenarioAudio(generateImageUrl('media/Freeplay/level4/chat/chat_conflict_prompt.mp3'));
            setScenarioExample(generateImageUrl('media/Freeplay/level4/chat/example_resolve_conflict.mp4'));
            setSecond(true);
        } else if(props.topicName === 'Self-Advocacy: Chat Challenge') {
            setScenario(generateImageUrl('images/newDesign/FreePlay/level4/Advocacy_Challenge_Scenario.png'));
            setScenarioText('You are at the snack shack and you need to know where the napkins are.');
            setScenarioAudio(generateImageUrl('media/Freeplay/level4/chat/chat_advocacy_prompt.mp3'));
            setScenarioExample(generateImageUrl('media/Freeplay/level4/chat/example_self_advocacy.mp4'));
            setSecond(true);
        } else if(props.topicName === 'Community Locations: Chat Challenge') {
            setScenario(generateImageUrl('images/newDesign/FreePlay/level4/Community_Challenge_Scenario.png'));
            setScenarioText('You need to buy new socks for yourself and you don’t know where they are in the clothing store.');
            setScenarioAudio(generateImageUrl('media/Freeplay/level4/chat/chat_community_prompt.mp3'));
            setScenarioExample(generateImageUrl('media/Freeplay/level4/chat/example_community_locations.mp4'));
            setSecond(true);
        } else {
            setIntro(true);
        }

    }, []);

    useEffect(() => {
        if (scrollRef.current) {
            scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
        }
    }, [revealedMessages, showReminder]);

    const currentStep = props.conversationFlow[currentStepIndex];

    const saveChatChallengeResult = async (finalScore, totalQuestions) => {
        try {
            await API.post('TIR', '/v3/student/result', {
            body: {
                student_id: login.studentid,
                metric: `${props.name}_chat_challenge`,
                result: JSON.stringify({
                created: new Date().toISOString(),
                //target is the total type of questions in the conversation flow
                values: [{ value: finalScore, target: totalQuestions }],
                }),
            },
            });
        } catch (error) {
            console.log(error);
        }
    };

    const handleNext = () => {
        const totalQuestions = props.conversationFlow.filter(step => step.type === 'question').length;
        
        if (showReminder) {
            // After showing reminder, add it to revealed messages and continue forward
            setRevealedMessages([...revealedMessages, { text: reminderText, type: 'reminder' }]);
            setShowReminder(false);
            
            // Move to next step instead of going back
            if (currentStepIndex < props.conversationFlow.length - 1) {
                setCurrentStepIndex(currentStepIndex + 1);
            } else {
                // Challenge completed
                saveChatChallengeResult(score, totalQuestions);
                props.finish(score, totalQuestions);
            }
        } else {
            // Add current step to revealed messages
            setRevealedMessages([...revealedMessages, currentStep]);
            
            if (currentStepIndex < props.conversationFlow.length - 1) {
                setCurrentStepIndex(currentStepIndex + 1);
            } else {
                // Challenge completed
                saveChatChallengeResult(score, totalQuestions);
                props.finish(score, totalQuestions);
            }
        }
    };

    const handleYes = () => {
        const totalQuestions = props.conversationFlow.filter(step => step.type === 'question').length;
        const newScore = score + 1;
        
        // Add current step to revealed messages
        setRevealedMessages([...revealedMessages, currentStep]);
        setScore(newScore);
        
        // Move to next step
        if (currentStepIndex < props.conversationFlow.length - 1) {
            setCurrentStepIndex(currentStepIndex + 1);
        } else {
            // Challenge completed
            saveChatChallengeResult(newScore, totalQuestions);
            props.finish(newScore, totalQuestions);
        }
    };

    const handleNo = () => {
        // Show reminder and continue forward
        setReminderText(currentStep.reminder);
        setShowReminder(true);
    };

    return (
        <div className='conversationBody chatChallengeBody'>
            {intro && (
                <div className='mainPage'>
                    <audio autoPlay>
                        <source src={scenarioAudio} type="audio/mp3"/>
                    </audio>
                    <div className='info'>
                        <img className='cover' alt="cover" src={Cover}/>
                        <h2 style={{color: 'darkblue', fontWeight: 600, marginTop: '20px'}}>Chat Challenge</h2>
                        <div className='instructions'>
                            <p style={{fontSize: '1.2rem', margin: '10px 0'}}>
                                <strong>{props.studentName}</strong>, you are going to take the Chat Challenge.
                            </p>
                            <p style={{fontSize: '1.2rem', margin: '10px 0'}}>
                                <strong>{props.friendName}</strong>, take the device and don't let <strong>{props.studentName}</strong> see the screen.
                            </p>
                        </div>
                        <div className="avatars">
                            <div className="avatar">
                                <h4 className="character-name">
                                    {props.studentName}:
                                </h4>
                                <div className="avatar-inner">
                                    <img alt="student avatar" src={generateImageUrl(props.selectedStudentCharacter.src)}/>
                                </div>
                            </div>
                            <div className="avatar">
                                <h4 className="character-name">
                                    {props.friendName}:
                                </h4>
                                <div className="avatar-inner">
                                    <img alt="friend avatar" src={generateImageUrl(props.selectedFriendCharacter.src)}/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='infoButton'>
                        <ButtonWithSound 
                            className='button start' 
                            onClick={() => {setIntro(false); setChallenge(true)}} 
                            label={"LET'S BEGIN!"}
                        />
                    </div>
                </div>
            )}
            {second && (
                <div className='mainPage'>
                    <audio autoPlay>
                        <source src={scenarioAudio} type="audio/mp3"/>
                    </audio>
                    <div className='info'>
                        <img className='cover' alt="cover" src={scenario}/>
                        <h3>{scenarioText}</h3>
                    </div>
                    <div className='infoButton'>
                        <ButtonWithSound 
                            className='button start' 
                            onClick={() => {setSecond(false); setFirst(true); setScenarioAudio(generateImageUrl('media/Freeplay/level4/chat/chat_instructions.mp3'))}} 
                            label={"WATCH AN EXAMPLE"}
                        />
                    </div>
                </div>
            )}
            {first && (
                <div className='video-container'>
                    <video className='video' autoPlay onEnded={() => {setFirst(false); setIntro(true)}}>
                        <source src={scenarioExample} type="video/mp4"/>
                    </video>
                </div>
            )}
            {challenge && (
                <div className="conversation-builder">
                    <h1 className="conversation-title">{props.topicName}</h1>
                    {<p className="conversation-subtitle">{props.friendName}, read the information below out loud.</p>}
                    
                    <div className="conversation-area" ref={scrollRef}>
                        {revealedMessages.map((message, index) => {
                            // Render questions as centered black text without speech bubble
                            if (message.type === 'question') {
                                return (
                                    <div key={index} className="question-text-container">
                                        <img 
                                            alt="friend avatar" 
                                            src={generateImageUrl(props.selectedFriendCharacter.src)}
                                            className="question-avatar"
                                        />
                                        <h2 className="question-title">{message.title}</h2>
                                        <p className="question-text">{message.text}</p>
                                    </div>
                                );
                            }
                            
                            // Render other messages as speech bubbles
                            const bubbleColor = message.type === 'reminder' ? '#ef4444' : 
                                              message.type === 'instruction' ? '#fbbf24' : '#3b82f6';
                            
                            return (
                                <div
                                    key={index}
                                    className="message-container message-right"
                                >
                                    <div 
                                        className={`message-bubble message-${props.selectedFriendCharacter.name}`}
                                        style={{backgroundColor: bubbleColor}}
                                    >
                                        <span className="emoji" role="img" aria-label="friend">
                                            <img alt="friend avatar" src={generateImageUrl(props.selectedFriendCharacter.src)}/>
                                        </span>
                                        <span className="message-text">{message.text}</span>
                                    </div>
                                </div>
                            );
                        })}

                        {showReminder && (
                            <div className="message-container message-right">
                                <div className={`message-bubble message-${props.selectedFriendCharacter.name}`} style={{backgroundColor: '#ef4444'}}>
                                    <span className="emoji" role="img" aria-label="friend">
                                        <img alt="friend avatar" src={generateImageUrl(props.selectedFriendCharacter.src)}/>
                                    </span>
                                    <span className="message-text">{reminderText}</span>
                                </div>
                            </div>
                        )}

                        {!showReminder && currentStep && (
                            currentStep.type === 'question' ? (
                                <div className="question-text-container">
                                    <img 
                                        alt="friend avatar" 
                                        src={generateImageUrl(props.selectedFriendCharacter.src)}
                                        className="question-avatar"
                                    />
                                    <h2 className="question-title">{currentStep.title}</h2>
                                    <p className="question-text">{currentStep.text}</p>
                                </div>
                            ) : (
                                <div className="message-container message-right">
                                    <div className={`message-bubble message-${props.selectedFriendCharacter.name}`} style={{backgroundColor: currentStep.type === 'instruction' ? '#fbbf24' : '#3b82f6'}}>
                                        <span className="emoji" role="img" aria-label="friend">
                                            <img alt="friend avatar" src={generateImageUrl(props.selectedFriendCharacter.src)}/>
                                        </span>
                                        <span className="message-text">{currentStep.text}</span>
                                    </div>
                                </div>
                            )
                        )}
                    </div>

                    <div className='character-container'>
                        <div className='left'>
                            <img alt="student character" src={generateImageUrl(props.selectedStudentCharacter.full)}/>
                        </div>
                        <div className="middle">
                            {showReminder || currentStep.type === 'instruction' ? (
                                <ButtonWithSound
                                    button={true}
                                    onClick={handleNext}
                                    className="next-button"
                                    label={showReminder ? "Next" : "Next"}
                                />
                            ) : (
                                <div className="validation-buttons">
                                    <ButtonWithSound
                                        button={true}
                                        onClick={handleYes}
                                        className="yes-button"
                                        label="Yes"
                                    />
                                    <ButtonWithSound
                                        button={true}
                                        onClick={currentStep.reminder ? handleNo : handleNext}
                                        className="no-button"
                                        label="No"
                                    />
                                </div>
                            )}
                        </div>
                        <div className='right'>
                            <img alt="friend character" src={generateImageUrl(props.selectedFriendCharacter.full)}/>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ChatChallenge;

